var R = require('ramda');

var hstIndex = require('./heatstress/_HeatStressGuidelinesIndex.json');

var guidelines = {};
hstIndex.guidelines.forEach(function (g) {
  guidelines[g._id] = R.clone(g);
  guidelines[g._id].guidelines = g.guidelines.map(function (gg) {
    return require("./heatstress/".concat(gg.file));
  });
});
var HST = {
  ALERT_ID: 'i-wbgt',
  colors: hstIndex.colors,
  guidelines: guidelines,
  guidelineIsMulti: function guidelineIsMulti(guideline) {
    return guideline.guidelines.length > 1;
  },
  getThreshold: function getThreshold(guideline, value) {
    var thresholds = guideline.zones;
    return R.reverse(thresholds).find(function (t) {
      return value >= t.above;
    });
  },
  thresholdUrl: function thresholdUrl(parentGuidelineId, guidelineLabel, zoneLabel) {
    if (!parentGuidelineId) return '';
    var guide = guidelines[parentGuidelineId];
    if (!guide) return '';
    var add = '';

    if (guidelineLabel && guide.label !== guidelineLabel) {
      add = "".concat(encodeURIComponent(guidelineLabel), "/");
    }

    return "https://ambientweather.net/hst/".concat(parentGuidelineId, "/").concat(add).concat(encodeURIComponent(zoneLabel));
  },
  getFinalGuildeline: function getFinalGuildeline(hst) {
    var guideline = HST.guidelines[hst.guideline];

    if (hst.guideline === 'custom') {
      guideline = hst.customGuideline;
      guideline.custom = true;
      guideline.name = 'Custom Guideline';
    } else {
      var origGuideline = guideline;

      if (HST.guidelineIsMulti(guideline)) {
        guideline = R.clone(guideline.guidelines.find(function (g) {
          return g.label === hst.level;
        }));
        guideline.name = origGuideline.label + ' - ' + guideline.label;
      } else {
        guideline = R.clone(guideline.guidelines[0]);
        guideline.name = origGuideline.label;
      }

      guideline._id = origGuideline._id;

      if (guideline.modifier && hst.modifier) {
        var mod = guideline.modifier.choices.find(function (c) {
          return c.label === hst.modifier;
        });
        guideline.zones = guideline.zones.map(function (z) {
          z.above = z.above - mod.offset;
          return z;
        });
      }
    }

    return guideline;
  }
};
module.exports = {
  HST: HST
};